import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useToast } from 'hooks/ui';
import { useApplicationStore } from 'store/application';
import { deleteUserGroup } from 'api/userGroups.service';
import { userGroupsKeys } from './queryKeys';

export const useUserGroupDeleteQuery = () => {
  const toast = useToast();
  const queryClient = useQueryClient();
  const { setLoading, removeLoading } = useApplicationStore((state) => state);

  const { isPending, mutate } = useMutation({
    mutationFn: (userGroupId: string) => {
      setLoading();

      return deleteUserGroup(userGroupId);
    },
    onSuccess: () => {
      toast.success('Group has been deleted successfully');
    },
    onError: (error: AxiosError) => toast.error(error.message),
    onSettled: () => {
      removeLoading();
      queryClient.invalidateQueries({ queryKey: userGroupsKeys.all });
    },
  });

  return { isLoading: isPending, mutate };
};
